import { defineAsyncComponent } from 'vue'

export default defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "template-constructor" */
    './TemplateConstructorModal.vue'
  )
) 